// extracted by mini-css-extract-plugin
export default {"NotificationPanelContainer":"Ug_daEaj"};